import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingService } from '@rogers/self-serve-utils/routing';
import { Observable } from 'rxjs';
import { Subnav, SubnavModule } from '@rogers/cdk/assembled/subnav';
import { Link } from '@rogers/cdk/link';
import { secondaryNavAnalyticsConfig } from './secondary-nav-analytics-config';
import { ROUTES_REGEX, SecondaryNavService } from './secondary-nav.service';
import { SelfServeAnalyticsService } from '@rogers/self-serve-analytics';
import { AsyncPipe } from '@angular/common';

const TRACK_EVENT_ROUTE_NAMES = ['orders', 'offers'];

@Component({
  selector: 'fss-secondary-nav',
  templateUrl: './secondary-nav.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [SubnavModule, AsyncPipe],
})
export class SecondaryNavComponent implements OnInit {
  private readonly selfServeAnalyticsService = inject(SelfServeAnalyticsService);
  private readonly router = inject(Router);
  private readonly routingService = inject(RoutingService);
  private readonly secondaryNavService = inject(SecondaryNavService);

  secondaryNavData$: Observable<Subnav>;

  get showSubNav() {
    return ROUTES_REGEX.test(this.router.url);
  }

  ngOnInit(): void {
    this.secondaryNavData$ = this.secondaryNavService.getSecondaryNavData$();
  }

  handleCtaClick(e: Link) {
    if (typeof e?.val === 'string') {
      this.trackEvent(e.val);
      this.routingService.navigate(e.val);
    }
  }

  private trackEvent(routeName: string) {
    if (routeName === 'promise-to-pay') {
      this.selfServeAnalyticsService.trackEvent(secondaryNavAnalyticsConfig.DropdownPromiseToPayCTAConfig);
    } else if (TRACK_EVENT_ROUTE_NAMES.includes(routeName) && !new RegExp(`^\/${routeName}`).test(this.router.url)) {
      this.selfServeAnalyticsService.trackEvent(secondaryNavAnalyticsConfig[routeName]);
    }
  }
}
